/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

const { abs, pow } = Math;

export default class Boom extends Phase {
	constructor() {
		super(0);
	}
	getPreludeLength() {
		return 0.5;
	}
	getPostludeLength() {
		return 0.5;
	}
	run({ time, pulse, frame_opts }) {
		const off = time.offBeat * 3;
		if (abs(off) < 1) {
			frame_opts.size *= 1 + 2 * pow(pulse, 20);
		}
	}
}
